import React, { useState } from 'react'

import Header from '../components/Header'
import Icon_Images from '../assets/ic_main_images.png'
import Icon_Videos from '../assets/ic_main_video.png'
import Icon_Audio from '../assets/ic_main_audio.png'
import Icon_Documents from '../assets/ic_main_documents.png'
import Icon_Contacts from '../assets/user.png'

import '../index.css'


const iconMap = {
    Images: Icon_Images,
    Audio: Icon_Audio,
    Videos: Icon_Videos,
    Documents: Icon_Documents,
    Contacts: Icon_Contacts
  };

  function Home() {
    let Categories = ["Images", "Audio", "Videos", "Documents", "Contacts"];


    function GoToDetails(cat , typename) {
        let type; 
        switch(cat) {
            case "Images":
                type = 0;
                break;
            case "Videos":
                type = 1;
                break;
            case "Audio":
                type = 2;
                break;
            case "Documents":
                type = 3;
                break;
            case "Contacts":
                type = 4;
                break;
            default:
                type = -1; // Handle unexpected values
        }
    
        window.location.href = `/details?type=${type}&typename=${typename}`;
    }




    
    return (
        <div>
            <Header />
            <div className='category-div ' >
                {Categories.map((cat, index) => (
                    <div key={index} className='category' onClick={()=>GoToDetails(cat , cat)}>
                        <img src={iconMap[cat]} alt={cat} />
                        <div className='d-flex flex-row justify-content-center align-items-center'>
                            <h3 className='text-light'>{cat}</h3>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white">
                                <polygon points="11.293 4.707 17.586 11 4 11 4 13 17.586 13 11.293 19.293 12.707 20.707 21.414 12 12.707 3.293 11.293 4.707"></polygon>
                            </svg>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
export default Home


